import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import {HelmetProvider} from "react-helmet-async";

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
const helmetContext = {};

root.render(
  <React.StrictMode>
    <HelmetProvider context={helmetContext}>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
